import { useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import { UpdateOrganizationMutation } from "src/api/Organization";
import { BorderButton } from "src/components/buttons/BorderButton";
import { ColorBlock } from "src/components/forms/ColorBlock";
import { ColorPicker } from "src/components/forms/ColorPicker";
import { useForm } from "src/components/forms/Form";
import { InputItem } from "src/components/inputs/InputItem";
import { InputText } from "src/components/inputs/InputText";
import Breadcrumbs from "src/components/layout/Breadcrumbs";
import Container from "src/components/layout/Container";
import OrganizationModel from "src/models/OrganizationModel";
import { apiClient } from "src/stores/Api";
import { useStore } from "src/stores/Store";
import { hexRegex } from "src/utils/constants";
import helmet from "src/utils/helmet";
import { useListBackground } from "src/utils/setListBackground";
import { updateOrganizationVariables } from "types/code-generator";

export default function Brand(props) {
  const store = useStore();
  const history = useHistory();
  const form = useForm<{
    color: string;
  }>();
  useListBackground();

  useEffect(() => {
    helmet.setPageTitle("Brand Color");
  }, []);

  const colorHex = form.getFieldValue("color")
    ? `#${form.getFieldValue("color")}`
    : store.organization?.color || "#2970ff";

  useEffect(() => {
    // console.log("colorHex", colorHex);

    if (
      colorHex.length === 7 &&
      hexRegex.test(colorHex.replace("#", "")) &&
      colorHex !== store.organization.color
    ) {
      onSubmit();
    }
  }, [colorHex]);

  async function onSubmit() {
    // console.log("color", color);
    form.setIsSubmitting(true);

    const variables: updateOrganizationVariables = {
      data: {
        color: colorHex,
      },
      where: {
        id: store.organization.id,
      },
    };

    const result = await apiClient(UpdateOrganizationMutation, {
      variables,
    });

    const organization = new OrganizationModel(result.updateOrganization);

    form.setIsSubmitting(false);

    store.setOrganization(organization);
  }

  return (
    <Container full main className="bg-white">
      <div className="border-b border-borderGray px-4 pb-4">
        <Breadcrumbs>
          <Link to="/admin">Home</Link> /{" "}
          <Link to="/admin/settings">Settings</Link> /{" "}
          <strong>Brand Color</strong>
        </Breadcrumbs>

        <h1 className="mb-0 sm:mb-2">Brand Color</h1>
      </div>

      <Container large>
        <div className="mb-6 mt-8">
          Your public screens and customer views will be white-labeled to your
          brand. We will help you look great, starting with your primary brand
          color.
        </div>

        <div className="mb-4">
          <ColorPicker
            value={colorHex}
            onChange={(color) => form.setFieldsValue({ color })}
          />
        </div>
        <div className="max-w-sm">
          <div className="flex gap-4">
            <div className="flex-1">
              <ColorBlock
                color={colorHex}
                className={form.isSubmitting ? "opacity-70" : ""}
              />
            </div>
            <div className="flex-1">
              <InputItem
                name="color"
                initialValue={colorHex.replace("#", "")}
                form={form}
                rules={[
                  {
                    pattern: hexRegex,
                    message: "Invalid Color",
                  },
                  {
                    required: true,
                    message: "Color is required",
                  },
                ]}
              >
                <InputText
                  placeholder="Brand Color"
                  prefix="#"
                  maxLength={6}
                  disabled={form.isSubmitting}
                />
              </InputItem>
            </div>
          </div>
        </div>

        <div className="pb-12 pt-6">
          <BorderButton onClick={() => history.goBack()}>
            Return to Settings
          </BorderButton>
        </div>
      </Container>
    </Container>
  );
}
